import { render, staticRenderFns } from "./stripe-status-tag.vue?vue&type=template&id=0042ce63&scoped=true&"
import script from "./stripe-status-tag.vue?vue&type=script&lang=js&"
export * from "./stripe-status-tag.vue?vue&type=script&lang=js&"
import style0 from "./stripe-status-tag.vue?vue&type=style&index=0&id=0042ce63&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0042ce63",
  null
  
)

export default component.exports